import React, { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import { useMapContext } from "./MapContext";
import { DrawerContentType, useDrawerContext } from "./DrawerContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import MapDashboard from "./MapDashboard";

const HandleRoute = () => {
  const { documentId } = useParams<{ documentId: string }>();
  const { setSelectedDocument } = useMapContext();
  const { setDrawerContentType } = useDrawerContext();

  useEffect(() => {
    if (documentId) {
      setSelectedDocument({ id: documentId });
      setDrawerContentType(DrawerContentType.VIEW_DETAILS);
    }
  }, [documentId, setSelectedDocument, setDrawerContentType]);

  return null; // This component doesn't render anything
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MapDashboard />}>
          <Route path="/issue/:documentId" element={<HandleRoute />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
